import React from 'react';

import MetaTags from '../shared/MetaTags';
import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import MiddleSection from './MiddleSection';

const CORPORATE_META_TITLE = 'The Information: Corporate Subscriptions & Team Plans';

const CorporateLanding = () => {
  return (
    <>
      <MetaTags
        title={CORPORATE_META_TITLE}
        ogSiteName="The Information"
        ogTitle={CORPORATE_META_TITLE}
        twitterTitle={CORPORATE_META_TITLE}
        description="Corporate Subscriptions"
        ogImagePath="'/global/og_images/Hero_IMG.png'"
      />
      <HeaderSection />
      <MiddleSection />
      <FooterSection />
    </>
  );
};

export default CorporateLanding;
